import Vue from 'vue'
import state from 'lib/appState'
import 'lib/polyfills'
import { handleize } from 'lib/util'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Swiper from 'swiper'

const thumbnailsCarousel = new Swiper('.product-gallery__list-thumbnails', {
  centeredSlides: false,
  slidesPerView: 'auto',
  preloadImages: true,
  // slideToClickedSlide: true,
  navigation: {
    nextEl: '.product-gallery__arrow.next',
    prevEl: '.product-gallery__arrow.prev'
  },
  direction: 'vertical'
})

export default el => new Vue({
  el,
  data () {
    return {
      key: 'color',
      activeIndex: 0,
      state,
      swiperOption: {
        lazy: {
          loadPrevNext: true
        },
        preloadImages: true,
        navigation: {
          nextEl: '.product-gallery__button-next',
          prevEl: '.product-gallery__button-prev'
        },
        pagination: {
          el: '.product-gallery__pagination',
          clickable: true
        },
        on: {
          slideChange: this.handleSlideChange
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  watch: {
    'state.activeVariant' () {
      this.activeIndex = 0
    },
    activeIndex () {
      if (this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.slideTo(this.activeIndex)
      }
    }
  },
  computed: {
    product () {
      return this.state.activeProduct
    },
    imageHandle () {
      for (let i = 0; i < this.product.options.length; i++) {
        const {options = []} = this.product
        const variant = this.state.activeVariant

        if (handleize(options[i]) === this.key) {
          const value = variant[`option${i + 1}`]

          if (!value) {
            return false
          }
          return `${this.key}-${handleize(value)}`.toLowerCase()
        }
      }
      return false
    },
    images () {
      const {images = []} = this.product
      return images
    },
    imagesAlt () {
      return this.product.images_alt
    },
    featuredImage () {
      return this.images[this.activeIndex] || null
    },
    filteredImages () {
      return this.product.images_with_alt.filter(image => image.alt.includes(state.activeVariant.sku))
    }
  },
  methods: {
    handleize,
    handleSlideChange () {
      this.activeIndex = this.$refs.swiper.swiper.activeIndex
    }
  }
})
